import React from 'react';
import { Link } from 'react-router-dom';

class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[calc(100vh-var(--nav-h))] bg-[#0B0B0B] flex items-center justify-center px-6">
          <div className="text-center">
            <p className="text-white/35 text-[6rem] font-display font-bold leading-none">Oops</p>
            <p className="text-white/50 text-lg mb-8">Something went wrong.</p>
            <Link to="/" onClick={() => this.setState({ hasError: false })}>
              <span className="inline-block px-8 py-3 bg-white text-black text-sm tracking-wider uppercase font-medium hover:bg-white/90 transition-all duration-300">
                Back to home
              </span>
            </Link>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
